import React from 'react';
import Container from '../Container';
import Content from '../Content';
import TraderRegistrationForm from './TraderRegistrationForm';

function RegistrationTrader(props) {
    return (
        <Container>

        <Content>
         

       <TraderRegistrationForm/>
        </Content>
    </Container>
    );
}

export default RegistrationTrader;